import API from './ks-engine'

const resource = 'tables';

export default {
  get (field) {
    return API.get(`/${resource}/${field}`)
  }
}